import React from "react";
import { default as WDivider } from "@mui/material/Divider";

function Divider(props) {
  return <WDivider {...props} />;
}

export default Divider;
